import { ResponseType } from 'axios';
import { HTTP_METHOD, ENDPOINT } from 'src/constants/api';
import { DTO } from './base.dto';

export interface IOtpBody {
	code: string;
}

export class OtpVerificationResponse {
	accountId?: string;
	token: string;
	email?: string;
	firstName?: string;
	middleName?: string;
	lastName?: string;
	companyName?: string;
	accountType?: number;
	isActive?: boolean;
	isFirstLogin?: boolean;
	constructor(data: OtpVerificationResponse) {
		this.token = data.token;
		this.email = data.email;
		this.firstName = data.firstName;
		this.middleName = data.middleName;
		this.lastName = data.lastName;
		this.accountType = data.accountType;
	}
}

export class OtpDTO extends DTO {
	public param: object | undefined;
	public query: undefined;
	public body: IOtpBody;
	public url: string = ENDPOINT.OTP_VERIFICATION;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseClass = OtpVerificationResponse;
	public readonly responseType: ResponseType = 'json';
	constructor(body: IOtpBody, headers: object) {
		super();
		this.body = body;
		this.headers = headers;
	}
}

export class ResendOTP extends DTO {
	public param: object | undefined;
	public query: object | undefined;
	public body: undefined;
	public url: string = ENDPOINT.RESEND_OTP;
	public method: HTTP_METHOD = HTTP_METHOD.GET;
	public readonly responseClass = String;
	public readonly responseType: ResponseType = 'json';
	constructor(headers: object, query: object | undefined) {
		super();
		this.headers = headers;
		this.query = query;
	}
}

export interface IResponseResendOTP {
	message: string;
	otpExpiredAt: Date;
}
